// extracted by mini-css-extract-plugin
module.exports = {"slider":"ImageSlider_slider__bWeW9","slidervalue":"ImageSlider_slidervalue__RDJUU"};